import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBDatatable, MDBIcon, MDBInput, MDBModalFooter, MDBSelect, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane, MDBTooltip } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";

import { useLocation, useNavigate } from "react-router";
import Loader from "../components/Loader";
import Popup from "../components/Popup";
import { deleteClassTransactions, getStaffInfo, getClass, getClassTransactions, getGBussinessInfo, getGymAddonsList, getPlans, getTokenCount, getTransactions, logEvent, authorzationOtp } from "../services/classApiServices.js";
import calImg from "../components/images/calendar.svg";
// import SideNavClass from "./SideNavClass";
import { isMobile } from 'react-device-detect';
import { formatDateTimeWithTZ } from "../utils/DateFormat"
import ExcelExportButton from "../components/exportToExcel";
import { browserName, browserVersion } from "react-device-detect";
import ClassTransactionDetails from "../components/class/classTransactionDetails";
import { useAnalytics } from "../hooks/useAnalytics";
import { useAccess } from "../context/AccessContext";




function ClassTransactions({ globlefilter, isapplied, globledateRange, handleclasstransactioninfo }) {
    console.log(globlefilter, 'globlefilter');

    const { trackButtonClick } = useAnalytics();
    const [modeOpen, setModeOpen] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [mode, setMode] = useState('side');
    const location = useLocation();
    const [apiError, setApiError] = useState(false);
    const [transid, settransid] = useState("")
    const [mfilter, setMfilter] = useState({
        inputText: "",
        classNme: [],
        tidName: "",
        contNme: "",
        startDate: "",
        endDate: "",
    });
    const [tId, setTId] = useState(null);
    const [filterr, setFilterr] = useState(false);
    const today = new Date();
    const currentTime = new Date();
    const startOfToday = new Date(currentTime);
    startOfToday.setHours(0, 0, 0, 0);

    const endOfToday = new Date(currentTime);
    endOfToday.setHours(23, 59, 59, 999);

    const yesterday = new Date(currentTime);
    yesterday.setDate(currentTime.getDate() - 1);
    const startOfYesterday = new Date(yesterday);
    startOfYesterday.setHours(0, 0, 0, 0);

    const endOfYesterday = new Date(yesterday);
    endOfYesterday.setHours(23, 59, 59, 999);

    const startOfWeek = new Date(currentTime);
    startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
    startOfWeek.setHours(12, 0, 0, 0);
    const endOfWeek = new Date(currentTime);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(12, 0, 0, 0);

    const startOfMonth = new Date(currentTime);
    startOfMonth.setDate(1);
    startOfMonth.setHours(0, 0, 0, 0);

    const endOfMonth = new Date(currentTime);
    endOfMonth.setMonth(currentTime.getMonth() + 1, 0);
    endOfMonth.setHours(23, 59, 59, 999);

    const startOfYear = new Date(currentTime);
    startOfYear.setMonth(0, 1);
    startOfYear.setHours(0, 0, 0, 0);

    const endOfYear = new Date(currentTime);
    endOfYear.setMonth(11, 31);
    endOfYear.setHours(23, 59, 59, 999);

    today.setHours(23, 59, 0, 0);
    const [dateRange, setDateRange] = useState([startOfMonth, today]);

    const [startDate, endDate] = dateRange;
    const [paymentLinkFilterss, setPaymentLinkFilterss] = useState(false)
    const [loading, setLoading] = useState(true);
    const [userData, setData] = useState([]);
    const [deleteTrans, setDeleteTrans] = useState(null);
    const [basicActive, setBasicActive] = useState("tab1");
    const [totalCount, setTotalcount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    const [totalPages, setTotalPages] = useState(1);
    const [applyFilterClicked, setApplyFilterClicked] = useState(false);
    const [DayFilter, setDayFilter] = useState(globlefilter ? globlefilter : "4");
    const [customdate, setcustomdate] = useState(DayFilter === "6");
    const [totalTranactions, setTotalTransaction] = useState(0)
    const [totalTranactionsCount, setTotalTractionCount] = useState(0)
    const [selectData, setSelectData] = useState([
        { text: 'Select', value: "Select" },

    ]);
    const [totalclassTransactionAmount, setTotalClassTransactionAmount] = useState(0)


    const { handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("classtransaction")


    const [notp, setNotp] = useState("");
    const [centredModal, setCentredModal] = useState(false)
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
    const otpRefs = useRef([]);
    const [error, setError] = useState("");
    const [resendTimer, setResendTimer] = useState(30);
    const handleOtpChange = (e, index) => {
        const value = e.target.value.replace(/[^0-9]/g, "");

        if (value) {
            const newOtp = [...otpDigits];
            newOtp[index] = value;
            setOtpDigits(newOtp);
            if (index < otpDigits.length - 1) {
                otpRefs.current[index + 1]?.focus();
            }
        }
    };
    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newOtp = [...otpDigits];
            if (otpDigits[index]) {
                // Clear current box
                newOtp[index] = "";
                setOtpDigits(newOtp);
            } else if (index > 0) {
                // Move back and clear
                otpRefs.current[index - 1]?.focus();
                newOtp[index - 1] = "";
                setOtpDigits(newOtp);
            }
        } else if (e.key === "ArrowLeft" && index > 0) {
            otpRefs.current[index - 1]?.focus();
        } else if (e.key === "ArrowRight" && index < otpDigits.length - 1) {
            otpRefs.current[index + 1]?.focus();
        }
    };
    useEffect(() => {
        if (resendTimer === 0) return;
        const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
        return () => clearInterval(timer);
    }, [resendTimer]);


    const otpfield = async (e) => {
        // e.preventDefault();
        const response = await authorzationOtp({ phone: JSON.parse(localStorage.getItem("loggedUserInfo")).number, value: !localStorage.getItem("loggedUserInfo") });

        let resData = await response.json();
        console.log(resData);
        if (resData.status != 200) {
            // setError(resData.status === 400 ? "Please try again." : "Number already exits in the system!")
        } else {
            // setError("OTP Sent Successfully");
            setCentredModal(true);
            setResendTimer(30);
            setNotp(resData.otp);
            setOtpDigits(Array(6).fill(""));
            otpRefs.current.forEach((input) => { if (input) input.value = ""; });
            setTimeout(() => { otpRefs.current[0]?.focus(); }, 100);
            setTimeout(() => { setNotp("") }, 300000);
        }
    }





    useEffect(() => {
        if (globlefilter) {
            setDayFilter(globlefilter);
            setcustomdate(globlefilter === "6");

        }
        if (globledateRange) {
            setDateRange(globledateRange)
        }
        if (isapplied) {
            setApplyFilterClicked(true);
        }
    }, [globlefilter, isapplied, globledateRange]);

    console.log(totalclassTransactionAmount, 'totalclassTransactionAmount');
    console.log(DayFilter, 'DayFilter');


    const [sdateRange, setSDateRange] = useState([]);
    const [sstartDate, sendDate] = sdateRange;



    const [classData, setClassData] = useState([])
    useEffect(() => {
        fetchPAData()
    }, [])


    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])

    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")
        } else {
            setMode("side")
        }
    }

    const closePopup = () => {
        if (isOpen) {
            setIsOpen(false);
        }
    };

    const togglePopup = (event, tId, _id, id) => {
        event.preventDefault();
        setTId(tId);
        setIsOpen(!isOpen);
        // setRid(id);
        settransid(_id)
    };

    async function fetchPAData() {
        if (localStorage.getItem("loggedUserInfo")) {
            const response = await getClass(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response) {
                return;
            }
            if (response === "false") {
                setApiError(true)
                return
            }
            const classinfo = await response.json();
            setClassData(classinfo)

        }
    }

    useEffect(() => {
        const itemSet = new Set();
        classData.length > 0 && classData.forEach(item => {
            if (item._id && item._id.length > 0) {
                itemSet.add({ text: item.name, name: item.name });
            }
        });
        const uniqueitem = Array.from(itemSet);
        const formatteditem = uniqueitem.map(item => ({
            text: item.text,
            value: item.name
        }));
        setSelectData(formatteditem);
    }, [classData]);
    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };
    const navigate = useNavigate();

    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])


    useEffect(() => {
        setcustomdate(DayFilter === "6" ? true : false);
    }, [DayFilter]);

    async function transactionDelete(e, data) {
        e.preventDefault();
        let id = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const flag = `Transaction deleted sucessfully ${fullName}`;
        await deleteClassTransactions(id, data._id);
        await trackButtonClick("ClassTransactionsIn", "Delete_ClassTransaction", "staff", {});
        setData(prevState => {
            const updatedValue = prevState.filter(obj => obj._id !== data._id);
            return updatedValue;
        });
        setDeleteTrans(null);
        await logEvent(
            {
                Eventtype: username1,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true
            },
            gymid
        );

    }

    const handleVerifyOTP = (e) => {
        const enteredOTP = otpDigits.join("");
        if (notp == "") {
            setError("Your OTP has expired. Please request a new one to continue.");
        } else if (enteredOTP !== notp) {
            setError("Invalid OTP.Please try again.");
        }
        else {
            setError("OTP verified Successfully. ");
            setCentredModal(false);
            transactionDelete(e, deleteTrans)
            // updateBusinessForm({ isnumberverified: true });
        }
    };



    const handleResetAndToggle = () => {
        setCurrentPage(1)
        setMfilter({
            classNme: [],
            tidName: "",
            contNme: "",
            startDate: "",
            endDate: "",
        });
        setDateRange([startOfMonth, endOfMonth])
        setDayFilter("4")
        setApplyFilterClicked(true);
        setSDateRange([])

        setFilterr((prevFilterr) => !prevFilterr);
        // fetchData();
        // return;
    };

    async function fetchData(sTxt) {
        if (localStorage.getItem("loggedUserInfo")) {
            location.filter = {};
            location.filter.tidName = mfilter.tidName
            location.filter.contNme = mfilter.contNme
            location.filter.classNme = mfilter.classNme
            location.limitmember = itemsPerPage;
            location.currentPage = (currentPage > 0 ? currentPage : 1);
            const dayFilter = DayFilter;
            const sDate = startDate;
            const eDate = endDate;

            setFilterr(filterr)
            setDateRange([startOfMonth, endOfMonth])

            let startOfDate = (dayFilter === "6" ? sDate : (dayFilter === "7" ? "" : (dayFilter === '1' ? startOfToday : (dayFilter === '2' ? startOfYesterday : (dayFilter === "3" ? startOfWeek : (dayFilter === "4" ? startOfMonth : (dayFilter === "5" ? startOfYear : (dayFilter === "6" ? sDate : ""))))))))
            let endOfDate = (dayFilter === "6" ? eDate : (dayFilter === "7" ? "" : (dayFilter === '1' ? endOfToday : (dayFilter === '2' ? endOfYesterday : (dayFilter === "3" ? endOfWeek : (dayFilter === "4" ? endOfMonth : (dayFilter === "5" ? endOfYear : (dayFilter === "6" ? eDate : ""))))))))

            setDateRange([startOfDate, endOfDate])

            if ((startOfDate && endOfDate)) {
                const startDatef = new Date(startOfDate)
                startDatef.setHours(0, 0, 0, 0)
                const utcstartDate = startDatef.toISOString();
                location.filter.startDate = utcstartDate;
                let lastoftheday = new Date(endOfDate);
                lastoftheday.setHours(23, 59, 59, 999);
                const utcEndDate = lastoftheday.toISOString();

                location.filter.endDate = utcEndDate;
                console.log(utcstartDate, utcEndDate);

            }

            if (sstartDate && sendDate) {
                const planStartDate = new Date(sstartDate);
                planStartDate.setHours(0, 0, 0, 0);
                location.filter.planStartDate = planStartDate.toISOString();

                const planEndDate = new Date(sendDate);
                planEndDate.setHours(23, 59, 59, 999);
                location.filter.planEndDate = planEndDate.toISOString();
            }


            const response = await getClassTransactions(
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
                location
            );
            if (!response) {
                return;
            }
            if (response === "false") {
                setApiError(true)
            } else {
                const usersData = await response.json();
                if (!usersData) {

                    navigate("/");
                    return;
                }
                console.log(usersData, '5555555555555555555555555555');

                setTotalTractionCount(usersData.uniqetotalTransactionsCount ? usersData.uniqetotalTransactionsCount : 0)
                setData(usersData.transctions);
                setTotalTransaction(usersData.totalPayment ? parseFloat((usersData.totalPayment).toFixed(2)) : 0)
                setTotalPages(usersData.transctions && usersData.transctions.length > 0 ? usersData.totalPages : 1)
                setTotalcount(usersData.totalTransactionsCount ? usersData.totalTransactionsCount : 0)
                setTotalClassTransactionAmount(usersData?.classTransactionsAmount ? usersData?.classTransactionsAmount : 0)
                handleclasstransactioninfo(usersData?.classTransactionsAmount ? usersData?.classTransactionsAmount : 0)
                if (currentPage > ((usersData.transctions && usersData.transctions.length > 0) ? usersData.totalPages : 1)) {
                    setCurrentPage(1)
                }
                setLoading(false)
                setApplyFilterClicked(false)
                localStorage.removeItem("transaction_filter1");
            }
        }
    }


    useEffect(() => {

        fetchData();
    }, [currentPage, itemsPerPage, applyFilterClicked]);

    let tmrow = [];
    const usersData = userData
    let uniqueTIds = new Set();
    usersData && usersData.length > 0 && usersData.forEach((data, ind) => {

        let rarray = [];
        const staffName = data.staff ? data.staff : {}
        rarray.push(ind + 1 + ((currentPage - 1) * itemsPerPage))
        rarray.push(
            // <button className="button-link link-color">{

            // }</button>
            <button className="button-link link-color" onClick={(event) => togglePopup(event, data.tid, data._id)}>{data.token ? data.token : data.tId}</button>
        );
        rarray.push(
            <MDBTooltip tag='div' title={data.membersid && data.membersid.length > 0 ? data.membersid.map(m => m.membername).join(", ") : ""}>
                {data.membersid && data.membersid.length > 0 ? data.membersid.map(m => m.membername).join(", ") : ""}
            </MDBTooltip>
        );
        rarray.push(<span className='trans-date'>{formatDateTimeWithTZ(data.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })}</span>);
        // rarray.push(<span className='trans-date'>{new Date(data.updatedAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })}</span>);
        rarray.push(data?.class && data.class.name ? data.class.name : "N/A");
        rarray.push(<span className='trans-date'>{formatDateTimeWithTZ(data.startdate).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })}</span>);
        rarray.push(<span className='trans-date'>{formatDateTimeWithTZ(data.expirydate).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })}</span>);
        rarray.push("₹" + ((data.totalamount).toLocaleString('en-IN')));
        rarray.push(data.refund && data.refund.refundamount ? "₹" + ((data.refund.refundamount).toLocaleString('en-IN')) : "0")
        rarray.push(data.mode ? data.mode : "--");
        rarray.push(data.quantity ? data.quantity : "--");
        rarray.push(staffName && staffName.firstname ? (staffName.firstname || staffName.lastname ? staffName.firstname + " " + staffName.lastname : staffName.username) : "")
        rarray.push(<MDBIcon fas icon="trash" onClick={(e) => setDeleteTrans(data)} />);
        tmrow.push(rarray);
        uniqueTIds.add(data.tId);

    });


    const basicData = {
        columns: [
            "S.no",
            "Order Id",
            "Member(s)",
            "Created Date",
            // "Updated Date",
            "class Name",
            "Start Date",
            "End Date",
            "Actual Price(incl.tax)",
            "Refund Amount",
            "Mode",
            "Quantity",
            "Trainer",
            "Delete",
        ],
        rows: tmrow,
    };

    const CalenderInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <span className="form-control select-input  placeholder-active me-3 shadow-1" onClick={onClick}>
                <p className="d-inline m-0 me-2">
                    {value === "" ? "Custom Range" : value}
                </p>
                <img src={calImg} ref={ref} alt="Custom Range" title="Select Custom Range" />
            </span>
        </>
    ));

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
        setLoading(true)
    };

    const prevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
        setLoading(true)
    };

    const handleApplyAndToggle = () => {
        setCurrentPage(1)
        setLoading(true)
        fetchData();
    }
    let RoleValue = JSON.parse(localStorage.getItem("loggedUserInfo"))
        ? (JSON.parse(localStorage.getItem("loggedUserInfo")).role
            ? JSON.parse(localStorage.getItem("loggedUserInfo")).role : "admin") : "staff";

    console.log(mfilter, '000000000000000000', selectData);




    const downloadtabledata = (data) => {
        if (
            !data ||
            !Array.isArray(data.columns) ||
            !Array.isArray(data.rows) ||
            data.columns.length === 0 ||
            data.rows.length === 0
        ) {
            console.log("Invalid or empty data for export.");
            return;
        }

        const filteredColumns = data.columns;

        const formattedData = {
            columns: filteredColumns,
            rows: data.rows.map((row) => {
                if (!Array.isArray(row)) return [];

                return row.map((cell) => {
                    if (typeof cell === "string") {
                        return cell.replace(/₹|,/g, "").trim();
                    }
                    return cell;
                });
            }),
        };

        const fileName = `Transaction_Export_${new Date()
            .toLocaleDateString("en-IN")
            .replace(/\//g, "-")}`;

        ExcelExportButton(formattedData, fileName);
        trackButtonClick("ClassTransactionsIn", "Export_ClassTransaction", "staff", {});
    };


    return (
        <>
            <MDBCard className='shadow-3 overflow-hidden'>
                <div>
                    <div className=" d-flex align-items-center flex-wrap w-sm-80 mb-3 mobileResloution">
                        <div className="gym-section order-0 me-2">
                            <label className="fw-bold">Search by {basicActive === "tab1" ? "OrderId/Transactions Id/Members" : "Transactions Id"}</label>
                            <div>
                                <input
                                    type="text"
                                    value={mfilter.tidName}
                                    className="form-control form-input select-input  placeholder-active me-3 shadow-1  "
                                    placeholder="search here..."
                                    onChange={(e) => {
                                        setMfilter({ ...mfilter, tidName: e.target.value })
                                        if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="gym-section w-300 w-100-mobile ms-2">
                            <label className="fw-bold">Class</label>
                            <div>
                                <MDBSelect
                                    clearButton
                                    placeholder="All"
                                    multiple search
                                    data={selectData}
                                    value={mfilter.classNme}
                                    onChange={(e) => {
                                        const selectedValues = e.map(item => item.value);
                                        setMfilter({
                                            ...mfilter,
                                            classNme: selectedValues
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="mob-w-100 ms-3 mob-m-0 ">
                            <label className="me-2 fw-bold"> Days </label>
                            <div>
                                <select
                                    name="shrs"
                                    id="shr"
                                    className="form-control form-input select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                                    onChange={(e) => {
                                        setDayFilter(e.target.value)
                                        if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                                    }}
                                    value={DayFilter}
                                >
                                    <option value="7">All</option>
                                    <option value="1">Today</option>
                                    <option value="2">Yesterday</option>
                                    <option value="3">This Week</option>
                                    <option value="4">This Month</option>
                                    <option value="5">This Year</option>
                                    <option value="6">Custom</option>
                                </select>
                            </div>
                        </div>
                        {customdate && <div className="gym-section order-2 ms-3">
                            <label className="fw-bold">Date</label>
                            <div className="gym-xlarge z-index_4 gym-larg-pos">
                                <div className="cursor-pointer">
                                    <DatePicker
                                        dateFormat={"d/M/yyyy"}
                                        selectsRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => {
                                            setDateRange(update);
                                            if (paymentLinkFilterss) setPaymentLinkFilterss(false);
                                        }}
                                        isClearable={false}
                                        customInput={<CalenderInput />}
                                    />
                                </div>
                            </div>
                        </div>}
                        <div className="gym-section w-100-mobile ms-2 align-self-end d-block">

                            <label className="fw-bold">Start Date Range</label>
                            <div className="w_200px w-100-mobile">
                                <div className="gym-xlarge gym-larg-pos">
                                    <DatePicker
                                        dateFormat={"d/M/yyyy"}
                                        selectsRange={true}
                                        startDate={sstartDate}
                                        endDate={sendDate}
                                        onChange={(update) => {
                                            // getDates(update)
                                            setSDateRange(update)
                                        }}
                                        isClearable={false}
                                        customInput={<CalenderInput />}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="gym-section order-5 ms-3 mb-0" >
                            <div className="">
                                <button type="submit" className="me-2 btn btn-primary custom-btn"
                                    onClick={(e) => handleApplyAndToggle()}
                                >
                                    Apply
                                </button>
                                <button type="submit" className="mt-2 btn btn-secondary custom-btn"
                                    onClick={(e) => handleResetAndToggle()}
                                >
                                    Clear
                                </button>
                                {roleAccess?.export == 1 &&
                                    <button type="submit" className="mr btn btn-primary custom-btn"
                                        onClick={(e) => downloadtabledata(basicData)}
                                    >
                                        <MDBIcon fas icon="download" className="d-inline me-1" />Export

                                    </button>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="datatable">
                        <div className="ClassTransactionsTable sno">
                            <table className="table datatable-table">
                                <thead className="datatable-header">
                                    <tr>
                                        {basicData.columns.map((column, index) => (
                                            <th key={index}>{column}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {!basicData.rows && loading ? (<h4> <Loader /></h4>) : basicData.rows.map((row, rowIndex) => (
                                        <tr key={rowIndex}  >
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex}>{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                    {!loading && basicData.rows.length === 0 &&
                                        <tr>
                                            <td colSpan={13}><p className="d-flex align-items-center justify-content-center"> No Data Found</p></td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>


                        {
                            roleAccess?.pagination == 1 &&

                            <div className="datatable-pagination">
                                Rows per page
                                <div className="ms-2 form-control w-auto">
                                    <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} className="Pagenation-Select">
                                        <option value="50">
                                            <div className="select-option">
                                                50
                                            </div>
                                        </option>
                                        <option value="100">
                                            <div className="select-option">
                                                100
                                            </div>
                                        </option>
                                        <option value="500">
                                            <div className="select-option">
                                                500
                                            </div>
                                        </option>
                                        <option value="1000">
                                            <div className="select-option">
                                                1000
                                            </div>
                                        </option>
                                    </select>
                                </div>
                                <button onClick={prevPage}
                                    disabled={currentPage === 1}
                                    className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark">
                                    Previous
                                </button>
                                <div className="d-flex justify-content-between w-120px align-items-center"> Page
                                    <input className="form-control w-50px" value={currentPage} onChange={(e) => setCurrentPage(Number(e.target.value))} />
                                    of {totalPages}</div>
                                <button onClick={nextPage}
                                    disabled={currentPage === totalPages}
                                    className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark">
                                    Next
                                </button>
                            </div>

                        }
                    </div>
                </div>
                {deleteTrans && (
                    <Popup
                        title="Confirm Delete"
                        content={
                            <>
                                <div className="pb-3">
                                    <span className="fs-6 pb-3">Are you sure you want to delete this entry?</span>
                                </div>
                                <MDBModalFooter>
                                    <MDBBtn color='secondary' onClick={(e) => setDeleteTrans(null)}>
                                        Cancel
                                    </MDBBtn>
                                    <MDBBtn color="danger"
                                        // onClick={(e) => transactionDelete(e, deleteTrans)}
                                        onClick={(e) =>
                                            roleAccess?.delete !== 3 ?
                                                transactionDelete(e, deleteTrans) :
                                                otpfield()
                                        }


                                    >Delete</MDBBtn>
                                </MDBModalFooter>
                            </>
                        }
                        handleClose={setDeleteTrans}
                    />
                )}
                {isOpen && (
                    <Popup
                        title="Transaction Details"
                        content={
                            <>
                                <ClassTransactionDetails
                                    oncancel={closePopup}
                                    // onAssociate={openAUserPop}
                                    gymid={localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1}
                                    id={tId}
                                    from="class"
                                    // Rtoken={Rid}
                                    transid={transid}
                                // filters={filteredobject}
                                />
                            </>
                        }
                        handleClose={closePopup}
                    />
                )}



                {centredModal && (<>
                    <Popup
                        title="Mobile Number Verification"
                        ptype="modal-md"
                        style=""
                        content={
                            <div className='text-center'>
                                <p>We've sent a One Time Password (OTP) to your mobile number <br />
                                    <strong>{"+91XXXXXXXXXX"}</strong>
                                </p>

                                <p className="mb-3">Please enter the 6-digit OTP below to verify your number.</p>

                                <div className="d-flex justify-content-center gap-2 mb-3">
                                    {[...Array(6)].map((_, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength={1}
                                            className="form-control text-center"
                                            style={{ width: "40px", fontSize: "1.2rem" }}
                                            value={otpDigits[index]}
                                            onChange={(e) => handleOtpChange(e, index)}
                                            onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                            ref={(el) => (otpRefs.current[index] = el)}
                                        />
                                    ))}
                                </div>

                                <p className="text-muted">
                                    Resend OTP in <strong>{resendTimer > 0 ? `00:${resendTimer.toString().padStart(2, '0')}` :
                                        <label onClick={(e) => otpfield(e)} className='button-link fw-600 text-primary fs-14px'>Now</label>}</strong>
                                </p>

                                <MDBBtn block className="mt-2" onClick={(e) => handleVerifyOTP(e)}>
                                    Verify OTP
                                </MDBBtn>
                            </div>
                        }
                        handleClose={() => setCentredModal(false)}
                    />
                </>
                )}

                {error && <MDBAlert
                    color={error.toLowerCase().includes('success') ? 'success' : 'danger'}
                    autohide
                    position='top-center'
                    delay={3000}
                    appendToBody
                    open={error}
                    onClose={() => { setError(null) }}
                    style={{ zIndex: 9999 }}
                >
                    {error}
                </MDBAlert>
                }


            </MDBCard>
        </ >
    )
}

export default ClassTransactions
